// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"IFiAGNU","industry-picker":"SyR1lZl","industryPicker":"SyR1lZl","secondary-title":"qeCZnJm","secondaryTitle":"qeCZnJm"};